import logiveryInfo from "~/data/logivery";
import { t } from "~/translations/utils";

export function Footer() {
  return (
    <footer className="footer has-background-black">
      <div className="content box has-background-black has-text-light has-text-centered">
        <span>{logiveryInfo.companyName}</span>
        <span className="mx-1">|</span>
        <span>
          {t("landing.footer.vat")} {logiveryInfo.vat}
        </span>
        <span className="mx-1">|</span>
        <span>
          {t("landing.footer.shareCapital")}: € {logiveryInfo.shareCapital}{" "}
        </span>
        <span className="mx-1">|</span>
        <span>
          {t("landing.footer.businessRegistry")}:{" "}
          {logiveryInfo.businessRegistry}
        </span>
        <span className="mx-1">|</span>
        <span>
          {t("landing.footer.sdi")}: {logiveryInfo.sdi}
        </span>
        <span className="mx-1">|</span>
        <span>{t("landing.footer.registeredOffice")}</span>
        <span>: </span>
        <span>{logiveryInfo.officeAddress}</span>
        <span className="mx-1">|</span>
        <span>
          <span>{t("landing.footer.certifiedEmail")}</span>
          <span>: </span>
          <span>{logiveryInfo.certifiedEmail}</span>
        </span>
        <span className="mx-1">|</span>
        <span>
          <span>{t("landing.footer.operationalHeadquarters")}</span>
          <span>: </span>
          <span>{logiveryInfo.operationalAddress}</span>
        </span>
        <span className="mx-1">|</span>
        <span>{t("landing.footer.email")}</span>
        <span>: </span>
        <span>{logiveryInfo.email}</span>
      </div>
    </footer>
  );
}
